<template>
  <div class="page-marketplace">
    <FrameHeader/>

    <div class="bg-white py-4">
      <div class="boxed d-flex align-items-center flex-wrap">

        <CpBtnSortList
          class="pc-ml-auto"
          v-model="on_filter"
        />
      </div>
    </div>

    <div class="boxed home-main-box pb-4">

      <div v-if="0" class="home-filter">
        <div class="mt-4 pt-2">
          <filterSet :form="filter_set"/>
        </div>
      </div>

      <div class="home-card-list w-100">

        <div v-if="!status_ajaxing_list">
          <div class="list-main-prod pb-5">
            <div class="item mb-4" v-for="(item,index) of list_on_show" :key="index">
              <CpCardProd :data="item"/>
            </div>
          </div>

          <div class="boxed">
            <CpPagination
              :mix_class="'justify-content-center'"
              :conf="pagination_cfg"
              @reloadList="getListOnShow"
            />
          </div>
        </div>

        <div>
          <div v-if="status_ajaxing_list" class="t-gray tac py-5">
            Loading... 
          </div>
          <!-- <CpLoadOnScroll 
            :fn_load_data="getListOnShow"
            :status_no_more_data="status_no_more_data"
          /> -->
        </div>
      </div>

    </div>

    <FrameFooter/>
  </div>
</template>

<script>


export default {
  name: 'pageHome',
  components: {
  },
  props: [],
  data() {
    return {
      on_tab: 'all',
      on_filter: '',

      status_ajaxing_list: false,
      list_on_show: [],

      // scroll load
      next_page_num: 1,
      status_no_more_data: false,

      pagination_cfg: {
        'page_size': 40, //每页条目数量
        'page_current': 1, // 当前页
        'count_items': 100, //总个数，和总页数选填其一
        'btn_num': 5, // 按钮个数
        'turnpage_top': true, // 翻页时操作滚动置顶
        'count_pages': 50, //总页数，和个页数选填其一 // 默认请给 0 值-便于首次加载时不露出分页器
      }
    }
  },
  computed: {},
  watch: {
    on_tab(){
      this.resetGetListFrom()
      this.getListOnShow()
    },
    on_filter(){
      this.resetGetListFrom()
      this.getListOnShow()
    },
    filter_set: {
      deep: true,
      handler(){
        this.resetGetListFrom()
        this.getListOnShow()
      },
    },
  },
  methods: {

    resetGetListFrom(){
      this.pagination_cfg.page_current = 1
      
      this.next_page_num = 1
      this.status_no_more_data = false
      this.list_on_show = []
    },
    
    async getListOnShow(){
      let v = this

      await v.api('list_asset',{
        'category': v.on_tab,
        'filter': v.on_filter,
        'filter_more': v.filter_set,
        // 'page_num': v.next_page_num,
        'page_num': v.pagination_cfg.page_current
      },{
        vue: v,
        key_data: 'list_on_show',
        key_ajaxing: 'status_ajaxing_list',
      })

      // if(res && res.data && res.data.length){
      //   v.list_on_show = v.list_on_show.concat(res.data)
      //   v.next_page_num += 1
      // }else{
      //   v.status_no_more_data = true
      // }
    },
    run(){
      let v = this
      v.on_tab = v.$route.query.store || 'all'
      v.getListOnShow()
    },
  },
  created() {
    this.run()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>

  .page-marketplace{

    .sp-banner{
      background-color: #D99230;
      text-align: center;
      img{
        max-width: 100vw;
        max-height: 485px;
      }
    }
    .sp-banner-text{
      background-color: #845C2F;
      color: #fff;
      max-width: 500px;
      margin: 0 auto;
      border-radius: 50px;
      padding: 5px 20px;
      font-size: 1.3em;
      text-align: center;
    }

    .home-main-box{

      @media(min-width: 788px){
        display: flex;

        .home-filter{
          width: 300px;
        }
        .home-cards-list{
          width: 100%;
        }
      }
    }
  }
</style>